import React, {Component} from 'react';
import './Group.css';
import {Link} from "react-router-dom";

class GroupFilter extends Component {

    render() {
        let className = "Voting-Group-Filter";
        if (this.props.active) {
            className += " active";
        }

        return (
            <Link to={"/filters/" + this.props.data.key.replace("/", "-")}  className={className}>
                {this.props.data.key}
            </Link>
        );
    }
}

export default GroupFilter;


// WEBPACK FOOTER //
// ./src/Components/Voting/GroupFilter.js